'use strict';

var React = require('react'),
    RectIcon = require('../RectIcon'),
    _ = require('lodash');

var IconValueRight = React.createClass({
    displayName: 'IconValueRight',


    propTypes: {
        icon: React.PropTypes.string,
        onClick: React.PropTypes.func,
        onIconClick: React.PropTypes.func,
        className: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array])
    },

    getDefaultProps: function getDefaultProps() {
        return {};
    },

    render: function render() {
        var className = _.concat(['icon-value', 'icon-value-right', 'f-t-auto', 'fields-tbl', 'f-t-middle'], this.props.className);
        var onClick = '';

        if (_.isFunction(this.props.onClick)) {
            onClick = this.props.onClick;
            className.push('clickable');
        }

        var icon = this.props.icon ? React.createElement(
            'div',
            { className: 'i-v-ico' },
            React.createElement(RectIcon, { onClick: this.props.onIconClick, imgSrc: this.props.icon })
        ) : '';

        return React.createElement(
            'div',
            { className: className.join(' '), onClick: onClick },
            React.createElement(
                'div',
                { className: 'i-v-content' },
                this.props.children
            ),
            icon
        );
    }

});

module.exports = IconValueRight;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Icon/IconValue/IconValueRight.js
// module id = 84
// module chunks = 0 1 2 3 4 5 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 28 29 30